function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { setCurrentVideo } from "@common/actions";
import { secondsToMilliseconds } from "@common/services/helpers";
import { API_URL, HAS_ACCESS, KEY_ENTER, KEY_SPACE, ORDER_SUBSCRIPTIONS_ENABLED, ROUTE_ORDER_SUBSCRIPTIONS, THUMBNAIL_OFFSET, VOD } from "@config/constants";
import { isEqual } from "lodash";
import LockedChannel from "./LockedChannel";
import ShowLogo from "./ShowLogo";
export var ShowImage = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(ShowImage, PureComponent);
    var _super = _create_super(ShowImage);
    function ShowImage(props) {
        _class_call_check(this, ShowImage);
        var _this;
        _this = _super.call(this, props);
        _define_property(_assert_this_initialized(_this), "playVideo", function(isUpcoming) {
            var _this_props = _this.props, show = _this_props.show, logo = _this_props.logo, userDetails = _this_props.userDetails;
            var isVod = _this.type === VOD;
            if (!isUpcoming && logo && (logo === null || logo === void 0 ? void 0 : logo.access) === HAS_ACCESS || isVod) {
                var currentEpg = isVod && _to_consumable_array(show.epgs).sort(function(a, b) {
                    var _a_numeration, _a_numeration1, _b_numeration, _b_numeration1;
                    return (a === null || a === void 0 ? void 0 : (_a_numeration = a.numeration) === null || _a_numeration === void 0 ? void 0 : _a_numeration.SeasonNumber) * 100 + (a === null || a === void 0 ? void 0 : (_a_numeration1 = a.numeration) === null || _a_numeration1 === void 0 ? void 0 : _a_numeration1.EpisodeNumber) - ((b === null || b === void 0 ? void 0 : (_b_numeration = b.numeration) === null || _b_numeration === void 0 ? void 0 : _b_numeration.SeasonNumber) * 100 + (b === null || b === void 0 ? void 0 : (_b_numeration1 = b.numeration) === null || _b_numeration1 === void 0 ? void 0 : _b_numeration1.EpisodeNumber));
                })[0];
                var epg = isVod ? _object_spread_props(_object_spread({}, currentEpg), {
                    chanId: currentEpg.id
                }) : show;
                _this.props.setCurrentVideo({
                    isOpen: true,
                    isPlaying: true,
                    channelId: epg.chanId,
                    allEpgs: isVod ? show.epgs : undefined,
                    video: {
                        start: epg.start,
                        stop: epg.stop,
                        duration: epg.stop - epg.start,
                        startPosition: -1,
                        isFullscreen: _this.props.videoPlayer.video.isFullscreen || false
                    }
                }, isVod);
                if (_this.props.hideOpenEpgsOnPlay) {
                    _this.props.hideOpenEpgs();
                }
            } else if ((logo === null || logo === void 0 ? void 0 : logo.access) !== HAS_ACCESS) {
                var _userDetails_planDetails;
                if (!(userDetails === null || userDetails === void 0 ? void 0 : (_userDetails_planDetails = userDetails.planDetails) === null || _userDetails_planDetails === void 0 ? void 0 : _userDetails_planDetails.oldClient) && ORDER_SUBSCRIPTIONS_ENABLED) {
                    _this.props.history.push(ROUTE_ORDER_SUBSCRIPTIONS);
                }
            }
        });
        _define_property(_assert_this_initialized(_this), "handleImageLoadError", function() {
            _this.setState({
                imageSrc: "/assets/media/no_info.jpg",
                zoomImage: true
            });
        });
        _define_property(_assert_this_initialized(_this), "renderLabel", function() {
            var _this_props = _this.props, i18n = _this_props.i18n, showHasLabel = _this_props.showHasLabel, show = _this_props.show, darkerThumbnail = _this_props.darkerThumbnail, videoPlayer = _this_props.videoPlayer, currentWatchedEpg = _this_props.currentWatchedEpg, showLiveLabel = _this_props.showLiveLabel;
            if (_this.type === VOD) return;
            var currentTimestamp = new Date().getTime();
            var isNow = currentTimestamp >= secondsToMilliseconds(show.start) && currentTimestamp < secondsToMilliseconds(show.stop);
            var isUpcoming = currentTimestamp < secondsToMilliseconds(show.start);
            var notNowLabel = isUpcoming ? i18n.common.upcoming : i18n.onRecord;
            var labelTemplate = null;
            if (show && videoPlayer && show.start === videoPlayer.video.start && show.stop === videoPlayer.video.stop && show.chanId === videoPlayer.channelId && typeof currentWatchedEpg !== "undefined") {
                labelTemplate = /*#__PURE__*/ _jsx("span", {
                    className: "show-label current",
                    children: i18n.common.now
                });
            } else if (showLiveLabel) {
                var classes = isNow ? "show-label now" : "show-label";
                var label = isNow ? i18n.live : notNowLabel;
                labelTemplate = /*#__PURE__*/ _jsx("span", {
                    className: classes,
                    children: label
                });
            } else if (showHasLabel) {
                var classes1 = "show-label";
                var label1 = null;
                if (isUpcoming) {
                    classes1 += " upcoming".concat(darkerThumbnail ? " dark" : "");
                    label1 = notNowLabel;
                }
                if (currentTimestamp > secondsToMilliseconds(show.stop)) {
                    classes1 += " on-record";
                    label1 = notNowLabel;
                }
                labelTemplate = label1 ? /*#__PURE__*/ _jsx("span", {
                    className: classes1,
                    children: label1
                }) : null;
            }
            return labelTemplate;
        });
        _define_property(_assert_this_initialized(_this), "loadImage", function() {
            var _this_props = _this.props, show = _this_props.show, darkerThumbnail = _this_props.darkerThumbnail, thumbnail = _this_props.thumbnail;
            var imageSrc = null;
            if (thumbnail) {
                imageSrc = thumbnail.src;
            } else {
                var currentTimestamp = new Date().getTime();
                var isUpcomingShow = secondsToMilliseconds(show.start) > currentTimestamp;
                var isPrevShow = secondsToMilliseconds(show.stop) < currentTimestamp;
                if (isUpcomingShow) {
                    imageSrc = "/assets/media/el-thumbs-".concat(darkerThumbnail ? "dark" : "light", ".jpg");
                } else if (isPrevShow) {
                    imageSrc = "".concat(API_URL, "/tumblrs/").concat(show.chanId, "/").concat(show.start + THUMBNAIL_OFFSET);
                } else {
                    imageSrc = "".concat(API_URL, "/tumblrs/").concat(show.chanId, "/latest");
                }
            }
            _this.setState({
                imageSrc: imageSrc
            });
        });
        _define_property(_assert_this_initialized(_this), "handleKeyDown", function(event, isUpcoming) {
            var key = event.which;
            if (key === KEY_ENTER || key === KEY_SPACE) {
                event.stopPropagation();
                _this.playVideo(isUpcoming);
            }
        });
        _define_property(_assert_this_initialized(_this), "handleMouseOver", function(isFocused) {
            var mouseOverHandler = _this.props.mouseOverHandler;
            if (mouseOverHandler) {
                mouseOverHandler(isFocused);
            }
        });
        _this.type = props.type || null;
        _this.state = {
            zoomImage: false
        };
        return _this;
    }
    _create_class(ShowImage, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.loadImage();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (!isEqual(prevProps, this.props)) {
                    this.loadImage();
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this_props_photos_find;
                var _this_props = this.props, hasAccess = _this_props.hasAccess, hasLogo = _this_props.hasLogo, hasLabel = _this_props.hasLabel, isInPlayer = _this_props.isInPlayer, logo = _this_props.logo, noImageEvents = _this_props.noImageEvents, show = _this_props.show, showHasLabel = _this_props.showHasLabel, tabIndexDynamic = _this_props.tabIndexDynamic, thumbnail = _this_props.thumbnail, locked = _this_props.locked;
                var _this_state = this.state, imageSrc = _this_state.imageSrc, zoomImage = _this_state.zoomImage;
                var showLogo = hasLogo ? /*#__PURE__*/ _jsx(ShowLogo, _object_spread({}, this.props)) : null;
                var showLabel = hasLabel || showHasLabel ? this.renderLabel() : null;
                var isUpcoming = new Date().getTime() < secondsToMilliseconds(show.start);
                var handlers = {};
                if (!noImageEvents) {
                    handlers.tabIndex = isInPlayer ? tabIndexDynamic : "0";
                    handlers.onKeyDown = function(event) {
                        return _this.handleKeyDown(event, isUpcoming);
                    };
                    handlers.onClick = function() {
                        return _this.playVideo(isUpcoming);
                    };
                    handlers.onFocus = function() {
                        return _this.handleMouseOver(true);
                    };
                    handlers.onBlur = function() {
                        return _this.handleMouseOver(false);
                    };
                }
                var altText = thumbnail ? thumbnail.alt : "";
                var thumbnailImage = (logo && logo.access === HAS_ACCESS || this.type === VOD && this.props.photos) && !locked ? /*#__PURE__*/ _jsx("img", _object_spread_props(_object_spread({}, thumbnail), {
                    draggable: "false",
                    src: this.props.photos && this.type == VOD && ((_this_props_photos_find = this.props.photos.find(function(e) {
                        return e.type === "poster";
                    })) === null || _this_props_photos_find === void 0 ? void 0 : _this_props_photos_find.url) || imageSrc,
                    alt: altText,
                    "aria-hidden": true,
                    onError: this.handleImageLoadError,
                    className: zoomImage && !thumbnail ? "zoom" : ""
                })) : locked ? /*#__PURE__*/ _jsx(LockedChannel, {}) : /*#__PURE__*/ _jsx("div", {
                    className: "default",
                    style: {
                        backgroundImage: 'url("/assets/media/paid_channel.jpg")',
                        position: "absolute",
                        top: 0,
                        left: 0
                    }
                });
                return /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({
                    className: "show-thumbnail".concat(isUpcoming || noImageEvents ? "" : " pointer")
                }, handlers), {
                    onMouseEnter: function() {
                        return _this.handleMouseOver(true);
                    },
                    onMouseLeave: function() {
                        return _this.handleMouseOver(false);
                    },
                    children: [
                        !thumbnail && logo && logo.access === HAS_ACCESS || hasAccess && thumbnail ? /*#__PURE__*/ _jsx("div", {
                            className: "show-thumbnail-overlay".concat(hasAccess ? " live" : "")
                        }) : null,
                        thumbnailImage,
                        !isUpcoming && logo && logo.access === HAS_ACCESS || hasAccess && thumbnail || this.props.photos ? /*#__PURE__*/ _jsx("span", {
                            className: "icon icon-play-circle"
                        }) : null,
                        showLabel,
                        showLogo
                    ]
                }));
            }
        }
    ]);
    return ShowImage;
}(PureComponent);
var mapStateToProps = function(param) {
    var currentChannel = param.currentChannel, userDetails = param.userDetails;
    return {
        currentChannel: currentChannel,
        userDetails: userDetails
    };
};
export default withRouter(connect(mapStateToProps, {
    setCurrentVideo: setCurrentVideo
})(ShowImage));
